import { AuthenticationResult, InteractionStatus } from '@azure/msal-browser'
import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { useEffect } from 'react'

import { loginRequest } from '../authConfig'
import { setAccessToken, setAuthenticated, setName } from '../store/authSlice'
import { useAppDispatch } from '../store/store.hooks'
import { logger } from '../utils/logger'

export const useAuth = () => {
  const dispatch = useAppDispatch()
  const { instance, inProgress, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      instance.loginRedirect(loginRequest).catch((e: unknown) => {
        logger.error('Login redirect error', e)
      })
    }

    if (isAuthenticated && inProgress === InteractionStatus.None) {
      const account = accounts[0]
      const request = { ...loginRequest, account }
      instance
        .acquireTokenSilent(request)
        .then((response: AuthenticationResult) => {
          instance.setActiveAccount(response.account)
          dispatch(setAccessToken(response.accessToken))
          dispatch(setAuthenticated(true))
          dispatch(setName(account.name))
        })
        .catch(() => {
          instance.acquireTokenRedirect(request)
        })
    }
  }, [isAuthenticated, inProgress, accounts, instance, dispatch])
}
